/**
 * InfoPanel
 *
 * Single inline panel that lists the artwork's full info underneath the
 * hero canvas. There used to be two variants — a bottom-sheet that
 * sequentially faded between detail / closeup for 3D works, and a
 * flat panel for image works. Anna preferred the flat layout
 * everywhere because nothing should overlap the sculpture and the
 * description has to be reachable without an extra click.
 */

import { Artwork } from '@/types/artwork'
import { ViewMode } from '@/types/three'
import { Markdown } from '@/components/ui/Markdown'
import { useFieldLang } from '@/context/LanguageContext'
import './InfoPanel.css'

interface InfoPanelProps {
  artwork: Artwork
  /** Legacy prop kept for callsite compatibility — no longer used. */
  viewMode?: ViewMode
}

export function InfoPanel({ artwork }: InfoPanelProps) {
  const pick = useFieldLang()
  const description = pick(artwork.description, artwork.description_en)
  return (
    <aside className="info-panel info-panel-image visible">
      <div className="info-panel-content">
        {artwork.material && (
          <div className="metadata">
            <span className="metadata-value">{artwork.material}</span>
          </div>
        )}
        {description && (
          <div className="artwork-description-block">
            <Markdown>{description}</Markdown>
          </div>
        )}
        {artwork.dimensions && <p className="artwork-dimensions">{artwork.dimensions}</p>}
        {artwork.year && <p className="artwork-year">{artwork.year}</p>}
      </div>
    </aside>
  )
}
